import { Box, useTheme } from "@mui/material";
import React from "react";

export default function HeaderLayout({ name }) {
  const theme = useTheme();
  return (
    <Box>
      <Box style={{ padding: "18px" }}>
        <p className="font-inter !pl-3 text-[18px] font-semibold">{name}</p>
      </Box>
      <div className="border"></div>
    </Box>
  );
}
